export default "__VITE_PUBLIC_ASSET__8683f23a__"